import React from "react";
import { getShorthandName } from "../../../../../utils/Helper";
import { toSentenceCase, toSentenceCaseCP } from "../../../../../global_functions/global";
import { Link, useNavigate, useLocation } from "react-router-dom";
import CommonTooltip from "../../../../common/Tooltip";
import { Button } from "../../../../common";

export const RelationTypeItem = ({ name, type, typeValue, country, broker_company_ID, insurer_company_ID, companyID, document = '' }) => {  
  const openurl = (id) => {
    if (id) {
      window.open("/search/" + id, '_blank');
    }
  }

  const handleDocument = (document) => {
    if (document) {
      window.open(document, '_blank');
    }
  }
  return (
      <div className="border-slate-400 flex  flex-col border rounded-lg p-3 min-w-[100%]">
        <div className="flex gap-2  border-b pb-4">
          <div>
            {false ? (
              <img
                src={false}
                className="rounded-full w-14 h-14 border-4 border-light"
                alt="user"
              />
            ) : (
              <div className="w-14 h-14 rounded-full flex items-center justify-center border border-lightGray shadow-md">
                <span
                  className={`text-profile ${getShorthandName(name || "").length > 2
                    ? "text-f12"
                    : "text-f14"
                    }`}
                >
                  {getShorthandName(name || "")}
                </span>
              </div>
            )}
          </div>
          <div className={`w-[calc(100%-62px)] text-start ${type === "Tax Number" ? "flex flex-col justify-center items-start" : ""}`}>
            <p className={`text-primary text-f16 sm:truncate ${(insurer_company_ID || companyID) ? "cursor-pointer" : "cursor-default"}`} onClick={() => openurl(insurer_company_ID || companyID)}>
              <CommonTooltip id={name} content={name} styles={{fontSize:"12px"}}>
              {name}
              </CommonTooltip>
              </p>
            <span className="text-secondary text-f14">
              {country}
            </span>
          </div>
        </div>
        <div className="text-start pt-2">
          <span className="text-secondary text-f12">{type?.split("_")?.join(" ")}</span>
          {
            broker_company_ID ?
              <p className={`text-f14 text-secondarytwo capitalize ${(broker_company_ID) ? "cursor-pointer" : "cursor-default"}`} onClick={() => openurl(broker_company_ID)}>{toSentenceCaseCP(typeValue)}</p>
              :
              <p className="text-f14 text-secondarytwo uppercase">{typeValue?.split("_")?.join(" ")}</p>
          }
        </div>
        {document && <div className="pt-2">
        <Button onClick={()=>handleDocument(document)} classes={'w-full bg-transparent text-[#3C4848] border border-[#EBF0F3] rounded-[4px] py-[10px] px-[18px] font-semibold'}>View Document</Button>
        </div>}
      </div>
  );
};
